<script>
import { ToolCategory } from '@/api'
import ListMixin from '@/crudBases/list/ListMixin'

export default {
  mixins: [ListMixin],
  data() {
    return {
      editRouteName: 'Edit Category',
      addRoute: { name: 'Add Category' },
      verboseName: 'Kategorię',
      verboseNamePlural: 'Kategorie',
      listFields: [
        { prop: 'id', label: 'id', width: 80 },
        { prop: 'title_pl', label: 'tytuł (pl)' },
        { prop: 'title_en', label: 'tytuł (en)' }
      ]
    }
  },
  computed: {
    service() {
      return ToolCategory
    }
  }
}
</script>
